import axios from "./axiosInstance";

const ReviewPreviewAPI = {
  getReviewPreview: () => axios.get(`/review`),
};

export default ReviewPreviewAPI;